import { useRbacObjectPermissions } from "../../../../../api/hooks";

export type SurveyAccessTier = "edit" | "view" | null;

export const useSurveyAccessTier = (surveyId: string): { tier: SurveyAccessTier; isLoading: boolean } => {
	const { data: permissions, isLoading } = useRbacObjectPermissions("surveys", surveyId);
	const tier = permissions?.includes("surveys:update")
		? "edit"
		: permissions?.includes("surveys:view")
			? "view"
			: null;
	return { tier, isLoading };
};
